import React, {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
  selectIsSubmitting,
  selectRemainingQuestions,
  selectSurveyAnswers,
  setGender
} from "../../redux/survey/macroSurveySlice";
import {Gender} from "../../models/fitnessProfile";
import {LocalizationInfo} from "react-i18next";
import {ManColorIcon, WomanColorIcon} from "../icons";
import {MacroSurveyOptionItemView} from "./MacroSurveyOptionItemView";
import {HeroHeading2} from "../text";
import {Button} from "../buttons/Button";
import {EventLogger} from "../../utils/eventLogger";
import {AnalyticsEvent} from "../../utils/eventProperties";

export interface MacroSurveyQuestionProps {

}

export const MacroSurveyGenderQuestionView: React.FC<MacroSurveyQuestionProps> = ({  }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const answers = useAppSelector(selectSurveyAnswers)
  const remainingQuestions = useAppSelector(selectRemainingQuestions)
  const isSubmitting = useAppSelector(selectIsSubmitting)

  const getTitle = (gender: Gender): LocalizationInfo => {
    switch (gender) {
      case Gender.male:
        return { key: 'macro_survey:macro_survey_title_male' }
      case Gender.female:
        return { key: 'macro_survey:macro_survey_title_female' }
    }
  }

  const getIcon = (gender: Gender): React.ReactNode => {
    switch (gender) {
      case Gender.male:
        return <ManColorIcon />
      case Gender.female:
        return <WomanColorIcon />
    }
  }

  const options: Gender[] = [Gender.male, Gender.female]
  const [genderAnswer, setGenderAnswer] = useState<Gender | undefined>(answers.gender)
  const [isValid, setIsValid] = useState<boolean>(false)

  useEffect(() => {
    EventLogger.logEvent(new AnalyticsEvent({ eventName: 'Screen Visited', screenName: 'Nutrition Survey' }, { 'Survey Question': 'Sex' }))
  }, [])

  useEffect(() => {
    if (genderAnswer) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [genderAnswer])

  return <div className="flex flex-col space-y-8 lg:space-y-10 items-center w-full">
    <HeroHeading2 className="text-center mx-8">{t('macro_survey:macro_survey_header_title_gender')}</HeroHeading2>

    <div className="w-full">
      {options.map(option => {
        return <div key={option.toString()} className="border-b border-fg-gray-surface last:border-b-0">
          <MacroSurveyOptionItemView
            item={{
              title: getTitle(option),
              id: option.toString(),
              isSelected: genderAnswer === option
            }}
            icon={getIcon(option)}
            isLoading={false}
            onItemSelected={() => {
              setGenderAnswer(option)
            }}
          />
        </div>
      })}
    </div>

    <div className="w-full px-5 md:justify-center md:flex">
      <Button
        isDisabled={!isValid}
        isLoading={isSubmitting}
        size="lg"
        isFullWidth={true}
        onClick={() => {
          genderAnswer && dispatch(setGender(genderAnswer))
        }}
      >
        {remainingQuestions.length ? t('common:common_title_continue') : t('common:common_title_submit')}
      </Button>
    </div>
  </div>
}